import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import MultiplePreview from 'ati-ui-react/widgets/MultiplePreview';
import getImgSrcWithPrefix from 'utils/getImgSrcWithPrefix';
import isEmpty from 'lodash/isEmpty';

import { useStores } from 'hooks/useStores';
import MainImage from './components/MainImage';
import Thumbs from './components/Thumbs';

import { GalleryStyles, GalleryContainer } from './GalleryStyles';

const Gallery = observer(() => {
  const [idCurrentPhoto, setIdCurrentPhoto] = useState(0);
  const {
    advertsStore: {
      currentAdvert: { photos, advert_item, advert_items },
    },
  } = useStores();

  if (isEmpty(photos)) return null;

  const currentBrand = advert_item?.brand?.name || advert_items[0].transport?.brand?.name;
  const currentModel = advert_item?.model?.model || advert_items[0].transport?.model?.model;

  const objectsPhoto =
    photos &&
    photos.map((link) => ({
      link,
      fileName: `${currentBrand} ${currentModel}`,
      mimeType: 'image/jpeg', // FIXME: надо определять тип
    }));

  const photosWithSizePrefix = photos.map((src) => getImgSrcWithPrefix(src, 'lg'));

  // FIXME: переписать эту лапшу
  const paginatePreview = (direction, current, files) => {
    if (direction === 'next') {
      if (files.length !== current + 1) {
        setIdCurrentPhoto(current + 1);
        return {
          src: files[current + 1],
          current: current + 1,
        };
      }
      setIdCurrentPhoto(0);
      return {
        src: files[0],
        current: 0,
      };
    }
    if (direction === 'prev') {
      if (current - 1 >= 0) {
        setIdCurrentPhoto(current - 1);
        return {
          src: files[current - 1],
          current: current - 1,
        };
      }
      setIdCurrentPhoto(files.length - 1);
      return {
        src: files[files.length - 1],
        current: files.length - 1,
      };
    }
    return false;
  };

  const Preview = (
    <GalleryContainer>
      <MainImage
        photos={photosWithSizePrefix}
        idCurrentPhoto={idCurrentPhoto}
        setIdCurrentPhoto={setIdCurrentPhoto}
      />
      <Thumbs
        photos={photosWithSizePrefix}
        idCurrentPhoto={idCurrentPhoto}
        setIdCurrentPhoto={setIdCurrentPhoto}
      />
    </GalleryContainer>
  );

  return (
    <GalleryStyles>
      <MultiplePreview
        button={Preview}
        current={idCurrentPhoto}
        fraction={objectsPhoto.length}
        paginate={(direction) => paginatePreview(direction, idCurrentPhoto, objectsPhoto)}
        locale="ru"
        showCurrentPosition={false}
        src={objectsPhoto[idCurrentPhoto]}
      />
    </GalleryStyles>
  );
});

Gallery.defaultProps = {
  truckName: 'Peugeout Expert',
};

export default Gallery;
